// extracted by mini-css-extract-plugin
export default {"tag":"wlbDnlQ15o_m9fpbTo3C"};